import {getVideoThumb} from '../fm/lib/util'

const updateVideoThumb = entity => {
	if(!entity.video) return entity
	const th = getVideoThumb(entity.video)
	if(!th) return entity
	let newEntity = {...entity}
	newEntity.thumb = [{url: th}]
	return newEntity
}
const nodeBundles = {
	article: {
		name: 'Articol',
		pathinfo: '/evenimente',
	},

	document: {
		name: 'Documentele școlii',
		pathinfo: '/documentele-scolii',
		tpl: 'Doc',
		fields: {
			title: {
				fullWidth: true
			}
		}
	},
	
	anunt: {
		name: 'Anunț',
		pathinfo: '/anunturi',
		tpl: 'Doc'
	},
	
	revista: {
		name: 'Revista școlii',
		pathinfo: '/revista-scolii',
		tpl: 'Doc'
	},

	video: {
		name: 'Video',
		pathinfo: '/media',
		tpl: 'Video',
		fields: {
			title: {
				fullWidth: true
			},
			video: {
				fullWidth: true
			}
		},
		presave: entity => 
			updateVideoThumb(entity.section
				?entity
				:Object.assign({}, entity, {section: {label: 'Media', path: '/media'}}))
	},

}

const entityTypes = {
	person: {
		name: 'Persoană',
		getLabel: entity => `${entity.first_name} ${entity.last_name}`
	},
	
	folder: {
		name: 'Dosar',
		getLabel: entity => entity.name
	},
	
	resource: {
		name: 'Resursă',
		getLabel: entity => entity.title
	},
	
	link: {
		name: 'Link util',
		getLabel: entity => entity.link?entity.link.label:'FĂRĂ TEXT'
	}
}
export {nodeBundles, entityTypes}



// WEBPACK FOOTER //
// ./src/conf/entityAdmin.js